/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SoftwareEnvironmentSpecLightSchema } from './SoftwareEnvironmentSpecLightSchema';
import {
    SoftwareEnvironmentSpecLightSchemaFromJSON,
    SoftwareEnvironmentSpecLightSchemaFromJSONTyped,
    SoftwareEnvironmentSpecLightSchemaToJSON,
} from './SoftwareEnvironmentSpecLightSchema';

/**
 * 
 * @export
 * @interface SoftwareEnvironmentAliasSchema
 */
export interface SoftwareEnvironmentAliasSchema {
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentAliasSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentAliasSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentAliasSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentAliasSchema
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentAliasSchema
     */
    specCount: number;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentAliasSchema
     */
    accountSlug: string;
    /**
     * 
     * @type {SoftwareEnvironmentSpecLightSchema}
     * @memberof SoftwareEnvironmentAliasSchema
     */
    latestSpec: SoftwareEnvironmentSpecLightSchema;
}

/**
 * Check if a given object implements the SoftwareEnvironmentAliasSchema interface.
 */
export function instanceOfSoftwareEnvironmentAliasSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "specCount" in value;
    isInstance = isInstance && "accountSlug" in value;
    isInstance = isInstance && "latestSpec" in value;

    return isInstance;
}

export function SoftwareEnvironmentAliasSchemaFromJSON(json: any): SoftwareEnvironmentAliasSchema {
    return SoftwareEnvironmentAliasSchemaFromJSONTyped(json, false);
}

export function SoftwareEnvironmentAliasSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SoftwareEnvironmentAliasSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'specCount': json['spec_count'],
        'accountSlug': json['account_slug'],
        'latestSpec': SoftwareEnvironmentSpecLightSchemaFromJSON(json['latest_spec']),
    };
}

export function SoftwareEnvironmentAliasSchemaToJSON(value?: SoftwareEnvironmentAliasSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'spec_count': value.specCount,
        'account_slug': value.accountSlug,
        'latest_spec': SoftwareEnvironmentSpecLightSchemaToJSON(value.latestSpec),
    };
}

